export default function AppSection() {
  return (
    <section id="app" className="py-16 md:py-24 bg-background-50">
      <div className="w-full max-w-[1024px] mx-auto px-4 md:px-6">
        <div className="rounded-2xl bg-gradient-to-br from-background-200 via-background-200/90 to-accent-500/8 border border-background-300/40 overflow-hidden">
          <div className="flex flex-col lg:flex-row items-center">
            <div className="flex-1 p-8 md:p-12 lg:p-14">
              <span className="inline-block px-3 py-1 text-xs font-medium text-accent-300 bg-accent-500/10 rounded-full mb-4">
                移动观影
              </span>
              <h2 className="text-2xl md:text-4xl font-bold font-heading text-foreground-50 mb-4">
                随时随地 · 掌上8848
              </h2>
              <p className="text-sm md:text-base text-foreground-400 leading-relaxed mb-8 max-w-[480px]">
                8848影院完美适配手机和平板设备。无需下载APP，打开浏览器即可享受流畅的高清观影体验。
                支持手势控制、横竖屏自动切换、一键投屏到电视，让你的观影不再受设备限制。
              </p>
              <div className="flex flex-col sm:flex-row gap-3">
                <div className="flex items-center gap-3 px-5 py-3 rounded-xl bg-background-300/50 border border-background-400/30 cursor-pointer transition-all hover:bg-background-300/70">
                  <i className="ri-smartphone-line text-accent-400 text-xl"></i>
                  <div>
                    <div className="text-xs text-foreground-400">手机访问</div>
                    <div className="text-sm font-medium text-foreground-200">浏览器直接打开</div>
                  </div>
                </div>
                <div className="flex items-center gap-3 px-5 py-3 rounded-xl bg-background-300/50 border border-background-400/30 cursor-pointer transition-all hover:bg-background-300/70">
                  <i className="ri-cast-line text-accent-400 text-xl"></i>
                  <div>
                    <div className="text-xs text-foreground-400">投屏观看</div>
                    <div className="text-sm font-medium text-foreground-200">大屏更过瘾</div>
                  </div>
                </div>
              </div>
            </div>
            <div className="lg:w-[360px] flex items-center justify-center p-8">
              <div className="relative">
                <div className="absolute inset-0 bg-accent-500/10 rounded-[2.5rem] blur-2xl"></div>
                <div className="relative w-[180px] md:w-[200px] aspect-[9/16] rounded-[2rem] border-2 border-background-400/50 overflow-hidden bg-background-200">
                  <div className="absolute top-0 left-0 right-0 h-8 bg-background-950/30 flex items-center justify-center">
                    <span className="text-[10px] text-foreground-500">8848影院</span>
                  </div>
                  <div className="mt-8 p-3 space-y-2">
                    <div className="h-24 rounded-lg bg-background-300/60 flex items-center justify-center">
                      <i className="ri-play-circle-fill text-accent-400 text-2xl"></i>
                    </div>
                    <div className="h-24 rounded-lg bg-background-300/60 flex items-center justify-center">
                      <i className="ri-play-circle-fill text-accent-400 text-2xl"></i>
                    </div>
                    <div className="h-24 rounded-lg bg-background-300/60 flex items-center justify-center">
                      <i className="ri-play-circle-fill text-accent-400 text-2xl"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}